import { render } from "./XIconSolidCalendarClock.vue?vue&type=template&id=6e7c7d04"
import script from "./XIconSolidCalendarClock.vue?vue&type=script&lang=js"
export * from "./XIconSolidCalendarClock.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidCalendarClock.vue"]])

export default __exports__